import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, Grid, Switch, IconButton, Tooltip } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";

import { Link, Navigate } from "react-router-dom";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export default class Announcements extends Component {
  state = {
    allAnnouncements: [],
    message: "",
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 10,
    },
    notification: false,
    noticolor: "success",
    per_page: 10,
    page_no: 1,
    redirect: false,
  };

  componentDidMount() {
    this.getAllAnnouncements(this.state.page_no, this.state.per_page);
  }

  // ✅ GET LIST
  getAllAnnouncements = (page, limit) => {
    if (init() === "success") {
      axios
        .post(Constants.getUrls.getAnnouncements, { page, limit })
        .then((resp) => {
          if (resp.data.status === true) {
            const items = resp.data.data.rows || [];
            const pag = resp.data.data.pagination || {};

            const currentPage = pag.currentPage || page;
            const perPage = pag.limit || limit;
            const totalDocs = pag.total || items.length;
            const totalPages = pag.totalPages || 1;

            this.setState({
              allAnnouncements: items,
              pagination: {
                page: currentPage,
                limit: perPage,
                totalDocs,
                totalPages,
                hasNextPage: pag.hasNextPage,
                hasPrevPage: pag.hasPrevPage,
              },
              page_no: currentPage,
            });
          }
        })
        .catch(() => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: "Error fetching announcements",
          });
        });
    } else {
      window.location.assign("/signin");
    }
  };

  // ✅ DELETE
  handleDelete = (id) => {
    if (!window.confirm("Delete this announcement?")) return;

    axios
      .post(Constants.deleteUrls.deleteAnnouncement, { id })
      .then(() => {
        this.getAllAnnouncements(this.state.page_no, this.state.per_page);
      });
  };

  // ✅ STATUS
  handleStatus = (id, status) => {
    const newStatus = status === "1" ? "0" : "1";

    axios
      .post(Constants.putUrls.changeAnnouncementStatus, {
        id,
        status: newStatus,
      })
      .then(() => {
        this.getAllAnnouncements(this.state.page_no, this.state.per_page);
      });
  };

  handlePageChange = (newPage) => {
    this.getAllAnnouncements(newPage, this.state.per_page);
  };

  handleEntriesPerPageChange = (limit) => {
    this.setState({ per_page: limit }, () => {
      this.getAllAnnouncements(1, limit);
    });
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/signin" replace={true} />;
    }

    const { pagination } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>

            {/* 🔥 HEADER */}
            <MDBox
              mx={2}
              mt={-6}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Announcements
              </MDTypography>
            </MDBox>

            {/* 🔥 ADD BUTTON */}
            <Grid item sm={4} px={2} align="right">
              <Link to="/addannouncement">
                <MDButton variant="contained" size="small" color="primary">
                  Create
                </MDButton>
              </Link>
            </Grid>

            <MDBox>
              <DataTable
                table={{
                  columns: [
                    { Header: "S.No", accessor: "serial" },
                    { Header: "Title", accessor: "title" },
                    { Header: "Status", accessor: "status" },
                    { Header: "Action", accessor: "action" },
                  ],

                  rows: this.state.allAnnouncements.map((item, index) => ({
                    serial:
                      (pagination.page - 1) * pagination.limit +
                      (index + 1),

                    title: item.title,

                    status: (
                      <Switch
                        checked={item.status === "1"}
                        onChange={() =>
                          this.handleStatus(item.id, item.status)
                        }
                      />
                    ),

                    action: (
                      <>
                        <Tooltip title="Edit">
                          <Link to={`/updateannouncement/${item.id}`}>
                            <IconButton color="info">
                              <EditIcon />
                            </IconButton>
                          </Link>
                        </Tooltip>

                        <Tooltip title="Delete">
                          <IconButton
                            color="error"
                            onClick={() => this.handleDelete(item.id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </>
                    ),
                  })),
                }}
                entriesPerPage={{ defaultValue: this.state.per_page }}
                page_no={pagination.page}
                totalPages={pagination.totalPages}
                hasNextPage={pagination.hasNextPage}
                hasPrevPage={pagination.hasPrevPage}
                totalDocs={pagination.totalDocs}
                onPageChange={this.handlePageChange}
                onEntriesPerPageChange={this.handleEntriesPerPageChange}
              />
            </MDBox>

            <MDSnackbar
              color={this.state.noticolor}
              title="Announcements"
              content={this.state.message}
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}